if(!customElements.get('filters-component')) {
  customElements.define(
    'filters-component',
    class FiltersComponent extends HTMLElement {
      #filterElements;
      #open;

      constructor() {
        super();
      }

      connectedCallback() {
        this.#filterElements = this.querySelectorAll('[data-filter]');
        if(!this.#filterElements?.length) return;
        
        this.#open = false;
        const triggers = document.querySelectorAll('[data-filters-trigger]');

        triggers.forEach(t => {
          t.addEventListener('click', this.#onTriggerClick.bind(this));
        });

        this.#filterElements.forEach(el => {
          if (el.type === 'range') {
            el.addEventListener('input', this.#onRangeInput.bind(this));
          }

          el.addEventListener('change', this.#onChange.bind(this));
        });
      }

      #onChange() {
        const event = new CustomEvent('query:change', {
          bubbles: true,
          detail: {
            purgeFilters: true
          }
        });
        this.dispatchEvent(event);
      }

      #onRangeInput(e) {
        const input = e.target;
        const slider = input.closest('.range-slider');

        const minInput = this.querySelector('input[data-price-bound="min"]');
        const maxInput = this.querySelector('input[data-price-bound="max"]');
        const fill = slider.querySelector('.range-fill');

        if (+minInput.value > +maxInput.value) {
          if (input.dataset.priceBound === 'min') {
            minInput.value = maxInput.value;
          } else {
            maxInput.value = minInput.value;
          }
        }

        const value = Intl.NumberFormat("en-GB", {
          currency: "GBP",
          minimumFractionDigits: 2
        }).format(Math.round(Number(input.value) / 10) * 10);
        input.value = value;
        
        const minEl = this.querySelector('[data-range-value="min"]');
        const maxEl = this.querySelector('[data-range-value="max"]');

        if (input.dataset.priceBound === 'min') {
          minEl.textContent = value;
        }

        if (input.dataset.priceBound === 'max') {
          maxEl.textContent = value;
        }

        const min = Number(minInput.value);
        const max = Number(maxInput.value);
        const rangeMax = Number(minInput.max);

        const left = (min / rangeMax) * 100;
        const width = ((max - min) / rangeMax) * 100;

        fill.style.left = `${left}%`;
        fill.style.width = `${width}%`;
      }

      #onTriggerClick() {
        this.classList.toggle('open');
      }
    }
  )
}